import React from 'react';

import MyTISectionHeader from './SectionHeader';
import type { MyTISectionProps } from './interfaces';

const MyTISection = ({ children, highlight, subtitle, title }: MyTISectionProps) => {
  return (
    <article className="mt-48 border-0 border-t border-solid border-grayscale-gray pt-48 sm:mt-80 sm:pt-80">
      <MyTISectionHeader highlight={highlight} subtitle={subtitle} title={title} />
      {children}
    </article>
  );
};

export default MyTISection;
